import React ,{useRef ,useEffect ,useState}from 'react';
import SecurityService from '../security/security.service';
import moment from 'moment'

import DynamicInputList from '../software-dynamic-version-2/list-input-v-2';
import DialogInput from '../software-dynamic-version-2/popup-dialog-input-v-2';


import TenantContractPMAdd  from './tenant-contract-pm-add'
import TenantContractPMService from './tenant-contract-pm.service';
import AuditTable from '../audit-table/audit-table';
import './tenant-contract-pm.scss'
import securityService from '../security/security.service';



const TenantContractPMInput = (props) => {
    // let handleCheckboxChange = (e,props)=>{
    //   console.log(e)
    //   TenantContractPMService.delete(props.UserID).then(async (res)=>{
    //     document.getElementById(`checkbox_${props.UserID}`).checked =false
    //     await  showDialog('ALERT' ,<span class="error-success">User Actived</span>)
    //       // await getListService()
    //       })
    // }
    // {
    //   buttonOption: { id: 'email', content: 'E', cssClass: 'e-flat', isPrimary: true, },
    // },
    // {
    //   buttonOption: { id: 'message', content:  'M', cssClass: 'e-flat', isPrimary: true, },
    // },
    // {
    //   buttonOption: { id: 'uploadPDF', content:  'A', cssClass: 'e-flat', isPrimary: true, },
    // }
    let columns =[
      {  field: "Commands",headerText:'Commands',width:'220',textAlign:'center' ,headerTextAlign:'center',other:[
        {button:[
          {Id:'UploadFiles',Content:'Upload Files', BgColor:'#2c842d' ,Color:'#f4f4f4',
            Input:{
            Route:'UploadFilesPM' ,
            Title:'Upload Files', 
            Security:'Tenant Contract',
            Width:'1000px' 
          }}
        ]}
      ]},
      { field: "TenantContractPMID", headerText:'Account ID', width:'100px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "CompanyName", headerText:'Company Name', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      // { field: "CompanyID", headerText:'Company ID', width:'100px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "TenantContractPMDate", headerText:'Contract Date', width:'130px', textAlign:'center', headerTextAlign:'center', other:[] },
      { field: "PropertyOwnerName", headerText:'Property Owner', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "CompanyRepresentedBy", headerText:'Owner Name', width:'180px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "AccountTitle", headerText:'Account Title', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      // { field: "AccountID", headerText:'Account ID', width:'100px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "TenantTradeLicenseNo", headerText:'Tenant Trade License No', width:'180px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "TenantRepresentedBy", headerText:'Tenant Represented By', width:'180px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "TenantPassportEIDNo", headerText:'Tenant Passport/EID No', width:'180px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "Nationality", headerText:'Nationality', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },

      // { field: "NationalityID", headerText:'Nationality ID', width:'100px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "TenantEmail", headerText:'Tenant Email', width:'200px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "TenantCellNo", headerText:'Tenant Cell No', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "ContractStartDate", headerText:'Contract Start Date', width:'130px', textAlign:'center', headerTextAlign:'center', other:[] },
      { field: "ContractEndDate", headerText:'Contract End Date', width:'130px', textAlign:'center', headerTextAlign:'center', other:[] },
      { field: "RentAmountAED", headerText:'Rent Amount (AED)', width:'130px', textAlign:'right', headerTextAlign:'center', other:[{format:'n2'}] },
      { field: "DiscountAmountAED", headerText:'Discount Amount (AED)', width:'150px', textAlign:'right', headerTextAlign:'center', other:[{format:'n2'}] },
      { field: "NetRentAmountAED", headerText:'Net Rent Amount (AED)', width:'150px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "ContractAmountAED", headerText:'Contract Amount', width:'130px', textAlign:'right', headerTextAlign:'center', other:[{format:'n2'}] },
      { field: "AccountTitleAgent", headerText:'Agent Name', width:'100px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "AgentCommissionPercent", headerText:'Agent Commission %', width:'100px', textAlign:'right', headerTextAlign:'center', other:[{format:'n2'}] },
      { field: "AgentCommissionAmount", headerText:'Agent Commission Amount', width:'100px', textAlign:'right', headerTextAlign:'center', other:[{format:'n2'}] },

          ];

        const listActionComplete = async (grid , args ,getListService ,selectedRow  ,setDataSourceState ,addUserLog,editUserLog)=>{
          console.log(args )
          console.log(getListService )
          console.log(selectedRow )
    
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        if(args.requestType == 'save' ){
        //   let data = {
        //     CompanyID: securityService.getCompanyIDLoggedInUserId(),
        //     TenantContractPMDate: args.data.TenantContractPMDate,
        //     CompanyRepresentedBy: args.data.CompanyRepresentedBy,
        //     AccountID: args.data.AccountID,
        //     TenantTradeLicenseNo: args.data.TenantTradeLicenseNo,
        //     TenantRepresentedBy: args.data.TenantRepresentedBy,
        //     TenantPassportEIDNo: args.data.TenantPassportEIDNo,
        //     NationalityID: args.data.NationalityID,
        //     TenantEmail: args.data.TenantEmail,
        //     TenantCellNo: args.data.TenantCellNo,
        //     ContractStartDate: args.data.ContractStartDate,
        //     ContractEndDate: args.data.ContractEndDate,
        //     RentAmountAED: args.data.RentAmountAED,
        //     DiscountAmountAED: args.data.DiscountAmountAED,
        // }
    
          console.log(args.data)
        // if(args.action == 'add'){
        //   TenantContractService.update(data).then(async (res)=>{
        //     await getListService()
        //     // inputName ,tableName,tableID,values
        //     // addUserLog('TenantContract'  ,'TenantContract',selectedRow,{
        //     //   UserName:args.data.UserName,
        //     //   UserFullName:args.data.UserFullName,
        //     // })
        //   })
        // }
        if(args.action == 'edit' || args.action == 'add' ){
          TenantContractPMService.update(
            {
              ...args.data,
              ContractStartDate: moment(args.data.ContractStartDate).format('DD-MMM-YY'),
              ContractEndDate: moment(args.data.ContractEndDate).format('DD-MMM-YY'),
              TenantContractPMDate: moment(args.data.TenantContractPMDate).format('DD-MMM-YY'),
            }).then((res)=>{
            getListService()
            // tableName,tableIDValue,selectedRows,values
            // editUserLog('TenantContractPM',args.data.UserID,'UserID',{
            //   UserName:args.data.UserName,
            //   UserFullName:args.data.UserFullName,
            // })
          })
        }
        }
        
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = false
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = true
    let  allowDataBound = true
    let  allowGridSum = false
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
        // @default TenantContractPM${typeMode} 
        let ListSecurity='Tenant Contract'
        let AddSecurity='Tenant Contract'
        let EditSecurity='Tenant Contract'
        let DeleteSecurity='Tenant Contract'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      // let toolbarOptions ='All';
      let toolbarOptions =['Add','Edit', 'Delete' ,'Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'].filter(Boolean);
          

        //   const dialogRef = useRef(null);
        //   const showDialog = (header,title,actions =['OK']) => {
        //     return new Promise((resolve) => {
        //     // Destroy existing dialog if any
        //     if (dialogRef.current) {
        //       dialogRef.current.destroy();
        //     }
        //     const okButtons = actions.map((action) => ({
        //       buttonModel: {
        //         content: action,
        //         cssClass: 'e-flat',
        //         isPrimary: action === 'OK',
        //       },
        //       click: (e) => {
        //         hideDialog();
        //         resolve(action);
        //       },
        //     }));
        //     // Create a new dialog instance
        //     dialogRef.current = new DialogInput({
        //       content: ()=>(<>{title}</>),
        //       header:header,
        //       width:'340px',
        //       showButtons: true,
        //       buttons:okButtons
        //     });
        //     // Show the dialog programmatically
        //     dialogRef.current.show();

        //   });

        //   };
        // const hideDialog = () =>{
        //   if (dialogRef.current) {
        //   }
        //   dialogRef.current.hide();
        //   dialogRef.current.destroy();
        //   dialogRef.current = null; // Clean up reference after destruction
        // }

      const toolbarClicking =  async (grid , args , selectedRow , getListService)=>{
        console.log(grid , args)
        console.log(selectedRow)
      //   if(props.Active ==  false  ){
      //      if(args.name == "rowSelected" || args.name == "rowDeselected"){
      //     if(args.target?.type ==  'checkbox'){
      //   setTimeout( async () => {
          
      //     await getListService()
      //   }, 1500);
      // }
      // }
    
      // }
      //   if(args?.item?.properties?.id == 'IsActive'){
      //     if(selectedRow == undefined){
      //   await showDialog('WARNING' ,<span class="error-tooltip">Please select a row first!</span>)
      // }else{
      //   let dialogResult  = await showDialog('Confirmation' ,<span class="error-success">Are you sure you want to delete?</span> , ['OK','CANCEL'])
      //   console.log(dialogResult)
      // if(dialogResult == 'OK'){
      //   TenantContractPMService.delete(selectedRow.UserID).then(async (res)=>{
      //   await  showDialog('ALERT' ,<span class="error-success">RECORD(S) DELETED SUCESSFULLY</span>)
      //     await getListService()
      //       AuditTable.auditDelete('TenantContractPM',selectedRow.UserID,{
      //         UserName:selectedRow.UserName,
      //         FullName:selectedRow.FullName,
      //       })
      //     })
      //   }
      //   }
      //   }
        
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'TenantContractPM' ,
                    TableID:'TenantContractPMID',
                   // Optional if Delete is Soft // TableSecurity:'TenantContractPMDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'TenantContractPM' ,TableID:'TenantContractPMID', Optional // TableSecurity:'TenantContractPMDelete'}]

  let listDelete=[{ TableName:['TenantContractPM_AdditionalPaymentDetail','TenantContractPM_PaymentDetail','TenantContractPM_PropertyDetail','TenantContractPM'] ,TableID:['TenantContractPMID']}]
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
    //  let filterColumns = [{ field: 'IsActive', value: props?.Active == false ? 'No' : 'Yes' }];
     let filterColumns = [];
      

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
      
        <DynamicInputList
        Id='TenantContractPM'
        ListTitle='Tenant Contract - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> TenantContractPMService.getTenantContractPMForList(securityService.getCompanyIDLoggedInUserId())
                        }]}
        DefaultSortedColumnName={'TenantContractPMID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<TenantContractPMAdd GridID={'TenantContractPM'} CompanyID={securityService.getCompanyIDLoggedInUserId()} />
        
            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            AllowTemplate={allowTemplate}
            // ToolbarOption={toolbarOptions}
            AllowGrouping={allowGrouping}
            AllowExcelExport={allowExcelExport}
            AllowPdfExport={allowPdfExport} 
            ShowColumnChooser={showColumnChooser}
            AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
            DefaultSortedColumnSort={DefaultSortedColumnSort}
            FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            GroupColumns={groupColumns} 
            ListDelete={listDelete}
             DeleteType={deleteType} 
            GridEditSettingMode={gridEditSettingMode}
            GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            IsDialog={isDialog}

            {...props}
            ></DynamicInputList>

            );
}



export default TenantContractPMInput;
